module.exports = __webpack_public_path__ + "static/media/f_hairstyle_wavy_short_back_vector.66e41d22.svg";